import React, { useEffect } from 'react';
import { ToggleButtonGroup, ToggleButton, Row, Col } from 'react-bootstrap';
import { PieGrid } from './PieGrid';
import BarChart from './BarChart';
import { useSelector } from 'react-redux';
import { readMainDepartments, getOwnersByDept } from '../api';
import { verifyRole } from '../../../utils';
import { useQuery } from '@apollo/client';
import { DefaultProgressByOwner } from './DefaultProgressByOwner';

export const ProgressByDepartment = () => {
  const [chartTypeValue, setChartTypeValue] = React.useState(1);
  const { data: departmentData, error: departmentDataError, loading: departmentLoading } = useQuery(readMainDepartments);
  // cooperative extension shows in departmentData
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));
  const { data, error, loading } = useQuery(getOwnersByDept(user.currentRole.departmentId));
  // useEffect(() => {
  //   console.log('owner by dept: ', JSON.stringify(data));
  // }, [data]);
  const orderValue = 1;
  const showAllDepartments = () => {
    if (loading) return <div>loading...</div>;
    if (error) return <div>{JSON.stringify({ error })}</div>;

    if (chartTypeValue === 1) {
      return (
        <PieGrid
          orderVal={orderValue}
          defaultSortType='percent'
          departments={departmentData.departments}
          source={user.currentRole.source}
          isAdmin={user.currentRole.isAdmin}
        />
      );
    } else return <BarChart orderVal={orderValue} defaultSortType='total' departments={data} source={user.currentRole.source} />;
  };

  const showSingleDepartment = () => {
    if (departmentLoading) return <div>loading....</div>;
    if (departmentDataError) return <div>{JSON.stringify(departmentDataError)}</div>;

    if (data) {
      //let chartData = sortData(data.physicalOwnerView, sortOrder, sortType);

      return (
        <div className='pie-grid-container'>
          <DefaultProgressByOwner data={data} />
        </div>
      );
      /*
      if (user.currentRole.source === 'Capital') {
        return (
          <div className='pie-grid-container'>
            <CapitalProgressByOwner data={data} />
          </div>
        );
      } else {
        return (
          <div className='pie-grid-container'>
            <DefaultProgressByOwner data={data} />
          </div>
        );
      }*/
    }
    return null;
  };

  const renderProgressByRole = () => {
    let role = user.currentRole.roleName;
    if (verifyRole(role)) return showAllDepartments();
    return showSingleDepartment();
  };

  const renderChartButtons = () => {
    if (verifyRole(user.currentRole.roleName)) {
      return (
        <ToggleButtonGroup type='checkbox' onChange={() => setChartTypeValue(3 - chartTypeValue)} className='float-right z-index-0'>
          <ToggleButton value={1} size='sm' className='hover'>
            <i className='fas fa-chart-pie'></i> Pie Charts
          </ToggleButton>
          <ToggleButton value={2} size='sm' className='hover'>
            <i className='fas fa-chart-bar'></i> Bar Chart
          </ToggleButton>
        </ToggleButtonGroup>
      );
    }
  };

  return (
    <div className='m-5'>
      <Row>
        <Col md={6}>
          <h2 className='float-left'>Progress By Department</h2>
        </Col>
        <Col md={6}>{renderChartButtons()}</Col>
      </Row>
      {renderProgressByRole()}
    </div>
  );
};
